export function author(person) {
  return person ? `[${person.first_name} ${person.last_name}]` : null
}
